import { IConsentPreference } from './gdpr';

export type User = Record<string, unknown> & {
  collection: string;
  id: string;
  email: string;
};

export type UserRole = ('admin' | 'editor' | 'guest' | 'user') & string;

export type UserWithRoles = User & {
  roles: UserRole[];
};

export type IEndUser = UserWithRoles & {
  email: string;
  consentPreferences: IConsentPreference[];
  createdAt: string;
  updatedAt: string;
};
